export function hexToRgba(hex, alpha = 0.1) {
    // Remove # if present
    let cleanHex = hex.replace(/^#/, '');

    // If 3 characters, expand to 6
    if (cleanHex.length === 3) {
        cleanHex = cleanHex
            .split('')
            .map((ch) => ch + ch)
            .join('');
    }

    // Parse the 6-character hex
    const r = parseInt(cleanHex.substring(0, 2), 16);
    const g = parseInt(cleanHex.substring(2, 4), 16);
    const b = parseInt(cleanHex.substring(4, 6), 16);

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
